import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { Warning } from "@phosphor-icons/react";
import api, { localToday, formatApiErrorDetail } from "../lib/api";

// Posting is blocked unless the posting date is today (administrators excepted) — offer a one-click fix.
export const PostingDateHint = ({ doc, kind, isAdmin, onDone }) => {
  const today = localToday();
  const fix = useMutation({
    mutationFn: async () => (await api.post(`/${kind}/${doc.id}/posting-date`, { posting_date: today })).data,
    onSuccess: () => { toast.success(`Posting date set to ${today}`); onDone?.(); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  if (!doc?.id || doc.posted || doc.archived || (doc.posting_date || "").slice(0, 10) === today) { return null; }
  return (
    <div className="mt-1.5 flex items-start gap-1.5 text-[11px] text-amber-700" data-testid="posting-date-hint">
      <Warning size={13} weight="bold" className="mt-0.5 shrink-0" />
      <span>
        {isAdmin ? "Not today — as an administrator you can still post with this date." : "Must be today to post."}{" "}
        <button type="button" onClick={() => fix.mutate()} disabled={fix.isPending} className="font-semibold underline hover:text-amber-900" data-testid="posting-date-use-today">Use today</button>
      </span>
    </div>
  );
};
